import { render } from "./add-location-modal.vue?vue&type=template&id=60b2d240&scoped=true"
import script from "./add-location-modal.vue?vue&type=script&lang=js"
export * from "./add-location-modal.vue?vue&type=script&lang=js"

import "./add-location-modal.vue?vue&type=style&index=0&id=60b2d240&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b2d240"]])

export default __exports__